import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CalcOnlyExcursionPackageRequest,
  CalcOnlyExcursionPackageResponse,
  GetExcursionCalendarRequest,
  GetExcursionCalendarResponse,
  GetExcursionPickupHotelsRequest,
  GetExcursionPickupHotelsResponse,
  GetExcursionSearchOptionsRequest,
  GetExcursionSearchOptionsResponse,
  SearchOnlyExcursionPackagesRequest,
  SearchOnlyExcursionPackagesResponse
} from '@appTypes/api.types';
import { environment } from '@env/environment';

/** TravelDesk Plan 2b: Online.Api api/OnlyExcursionPackages - live search (D-21), re-check, pickup hotels. */
@Injectable()
export class ExcursionsApiService {
  readonly #httpClient = inject(HttpClient);
  readonly #apiEndPoint: string = environment.urls.api + '/OnlyExcursionPackages/';

  searchOnlyExcursionPackages(payload: SearchOnlyExcursionPackagesRequest) {
    return this.#httpClient.post<SearchOnlyExcursionPackagesResponse>(
      this.#apiEndPoint + 'SearchOnlyExcursionPackages',
      payload
    );
  }

  calcPackage(payload: CalcOnlyExcursionPackageRequest) {
    return this.#httpClient.post<CalcOnlyExcursionPackageResponse>(
      this.#apiEndPoint + 'CalcOnlyExcursionPackage',
      payload
    );
  }

  getPickupHotels(payload: GetExcursionPickupHotelsRequest) {
    return this.#httpClient.post<GetExcursionPickupHotelsResponse>(this.#apiEndPoint + 'PickupHotels', payload);
  }

  /** 25.09.2026: the cities and categories with excursions on sale in the country - the form's filters */
  getSearchOptions(payload: GetExcursionSearchOptionsRequest) {
    return this.#httpClient.post<GetExcursionSearchOptionsResponse>(this.#apiEndPoint + 'SearchOptions', payload);
  }

  /** 27.09.2026: the excursions on sale per day of a month - the date picker's day marks */
  getCalendar(payload: GetExcursionCalendarRequest) {
    return this.#httpClient.post<GetExcursionCalendarResponse>(this.#apiEndPoint + 'Calendar', payload);
  }
}
